<script>

    import { onMount } from 'svelte';

    let image_elem; 
    export let img;

    let caption = `"${img.title}", ${img.description}, ${img.size}`;

    onMount(() => { M.Materialbox.init(image_elem)});

</script>



<figure>
        <img bind:this={image_elem} class="materialboxed" height="100%" data-caption={caption} src="media/{img.filename}.jpg" alt={caption} title="{img.title}" data-title="{img.title}">
</figure>



<style>

figure {
    margin: 0.3em !important;
}

.materialboxed:not(.active) {
  object-fit: cover;
  width: 100%;
  max-height: 250px;
  height: 100%;
}

</style>